import React, { Component, Suspense } from "react";
import axios from "axios";
import _ from "lodash";
import { Progress, Col, Row } from "reactstrap";
import { Menu, Segment, Sidebar, Tab, Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";
import { saveAs } from "file-saver";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { Link } from "react-router-dom";
import Loader from "../../Global/Loader";
import { withRouter } from "react-router-dom";
import DataTable from "../Components/DataTable";
import { DatePicker, Skeleton, Button as ButtonAnt, Switch } from "antd";
import moment from "moment";
import { Services } from "../../../repositories/clients/Services";
import { Services as OrderServices } from "../../../repositories/clients/Services";
import FormFiltros from "./model/form";
import { IconNewComment } from "./Components/components/img";
import "./styles.scss";
import "./Components/styles/cards.scss";
import { createTheme, Tooltip } from "@mui/material";
import { withNamespaces } from "react-i18next";
import { openNotification } from "../Components/Notification";

const Map = React.lazy(() => import("../Components//Maps/map"));
const Ordentransport = React.lazy(() => import("./OrdenesTransport"));
const Comments = React.lazy(() => import("../Components/Comments"));

const statusInter = [
  { Estatus: "Instruccionado", EstatusId: 61, count: 0, key: 1 },
  { Estatus: "Reservado", EstatusId: 62, count: 0, key: 2 },
  { Estatus: "Carga Lista", EstatusId: 63, count: 0, key: 3 },
  { Estatus: "Recolectado", EstatusId: 64, count: 0, key: 4 },
  { Estatus: "Salida", EstatusId: 65, count: 0, key: 5 },
  { Estatus: "Arribó", EstatusId: 66, count: 0, key: 6 },
  { Estatus: "En transito a Entregar", EstatusId: 72, count: 0, key: 7 },
  { Estatus: "Entregado", EstatusId: 73, count: 0, key: 8 },
  // { Estatus: "Facturado", EstatusId: 71, count: 0, key: 9 },
];
const { RangePicker } = DatePicker;

const theme = createTheme({
  components: {
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          backgroundColor: "#fff",
        },
        track: {
          opacity: 0.2,
          backgroundColor: "#9d9d9c",
          ".Mui-checked.Mui-checked + &": {
            opacity: 0.7,
            backgroundColor: "#dedc00",
          },
        },
      },
    },
  },
});

class Trazabilidad extends Component {
  state = {
    previousPage: "",
    headers: [
      this.props.t("prioritary_shipment"),
      this.props.t("transport_mode"),
      this.props.t("status"),
      this.props.t("shipment_num"),
      this.props.t("transport_order"),
      this.props.t("shipment_type"),
      this.props.t("company"),
      this.props.t("shipper"),
      this.props.t("consignee"),
      this.props.t("carrier"),
      this.props.t("reference"),
      this.props.t("order_ref"),
      this.props.t("reference_type"),
      this.props.t("containers"),
      this.props.t("incoterm"),
      this.props.t("hbl"),
      this.props.t("mbl"),
      this.props.t("origin"),
      this.props.t("destination"),
      this.props.t("etd"),
      // this.props.t("newETD"),
      this.props.t("atd"),
      this.props.t("eta"),
      // this.props.t("newETA"),
      this.props.t("ata"),
      this.props.t("creation_date"),
      this.props.t("total_co2_generated"),
      this.props.t("traveled_kilometers"),
      this.props.t("average_co2"),
    ],
    keys: [
      "PriorityShipment",
      "TransportMode",
      "Status",
      "ShipmentNumber",
      "TransportOrderNo",
      "ShipmentType",
      "CustomerName",
      "ShipperName",
      "ConsigneeName",
      "Carrier",
      "CustomertRef",
      "refclientepo",
      "ReferenceType",
      "Containers",
      "IncotermCode",
      "HBL_HAWB",
      "MBL_AWB_PRO",
      "POL",
      "POD",
      "ETD",
      // "NewETD",
      "ATD",
      "ETA",
      // "NewETA",
      "ATA",
      "shipmentCreationDate",
      "CO2",
      "Distance",
      "Average",
    ],
    orderHeaders: [
      this.props.t("transport_order"),
      this.props.t("company"),
      this.props.t("shipper"),
      this.props.t("consignee"),
      this.props.t("order_ref"),
      this.props.t("contianer_num"),
      this.props.t("origin"),
      this.props.t("destination"),
      this.props.t("prioritary_shipment"),
      this.props.t("shipment_num"),
      this.props.t("status"),
      this.props.t("shipper"),
      this.props.t("consignee"),
      this.props.t("order_ref"),
      this.props.t("contianer_num"),
      this.props.t("etd"),
      // this.props.t("newETD"),
      this.props.t("atd"),
      this.props.t("eta"),
      // this.props.t("newETA"),
      this.props.t("ata"),
      this.props.t("total_co2_generated"),
      this.props.t("traveled_kilometers"),
      this.props.t("average_co2"),
    ],
    orderKeys: [
      "TransportOrderNo",
      "Customer",
      "Shipper",
      "Consignee",
      "RefCliente",
      "Containers",
      "POL",
      "POD",
      "PriorityShipment",
      "ShipmentNumber",
      "Status",
      "ShipperName",
      "ConsigneeName",
      "ServicesOrdersNoS",
      "ContainerNo",
      "ETD",
      // "NewETD",
      "ATD",
      "ETA",
      // "NewETA",
      "ATA",
      "CO2",
      "Distance",
      "Average",
    ],
    isMovil: false,
    loadercomments: false,
    viewModalComments: false,
    commentsData: [],
    users: [],
    rolId: this.props._rolId,
    userId: this.props._user,
    scrollLine: false,
    rowid: "",
    itemCommenSelect: {},
    respladoCatalogCombo: {},
    map: (
      <Suspense fallback={<div>Loading...</div>}>
        <Map
          polylineData={[]}
          heidIcon={20}
          disableDefaultUI={true}
          marker={[]}
          visible={true}
          type={"polylineDrawer"}
          data={[]}
          dataDrawer={""}
          // zoom={3}
        />
      </Suspense>
    ),
    clientesSelect: this.props.clients
      ? JSON.stringify(this.props.clients)
      : "[0]",
    activePage: 1,
    limit: 10,
    limitTCC: 10,
    catalogCombo: [],
    paramsxml: {},
    numberPageTCC: 1,
    activePageTCC: 1,
    totalPagesTCC: 1,
    numberPage: 1,
    totalPages: 1,
    pages: 0,
    numberPageOrder: 1,
    activePageOrder: 1,
    totalPagesOrder: 1,
    searchOrder: "",
    isSearchsearchOrder: false,
    excelOrderLoading: false,
    limitOrder: 10,
    pagesOrder: 0,
    totalPagesExt: 1,
    totalPagesExtTCC: 1,
    search: "",
    searchTCC: "",
    isSearch: false,
    excelShipmentLoading: false,
    totalCard: [],
    dataDrawer: "",
    visible: false,
    selected: "",
    polyline: [],
    shipmentsTCC: [],
    shipmentsTCCAux: [],
    shipmentsTCCOut: [],
    data: [],
    dataTable: [],
    dataAux: [],
    dataOut: [],
    labelSelected: "",
    loading: true,
    graphs: [],
    markers: [],
    dataMap: [],
    donutChart: [],
    extraFilter: "",
    priorityChecked: false,
    config: [
      {
        label: "",
        id: "commentView",
        key: "commentViewAction",
        minWidth: 43,
        maxWidth: 43,
        noclick: true,
        custom: (value, triggerFn) => (
          <div
            title={this.props.t("comments")}
            onClick={() => {
              this.setState(
                {
                  loadercomments: true,
                  viewModalComments: true,
                },
                () => this.getCommnets(value)
              );
            }}
          >
            {value.NewComments ? (
              <IconNewComment></IconNewComment>
            ) : (
              <span className="icon-comments icons-front-module" />
            )}
          </div>
        ),
      },
      {
        label: "",
        key: "TransportMode",
        minWidth: 30,
        maxWidth: 30,
        custom: (value) => {
          return value.PriorityShipment === "Si" ||
            value.PriorityShipment === "Yes" ||
            value.TCC === "1" ? (
            <span className="icon-priority-shipments icons-front-module orange" />
          ) : (
            false
          );
        },
      },
      {
        label: "",
        key: "TransportMode",
        minWidth: 60,
        maxWidth: 60,
        custom: (value) => {
          return (
            <div>
              {value.TransportModeCode ? (
                <span
                  style={{
                    color: value.TCC === "1" ? "#FE5229" : "#000a2e",
                  }}
                  className={this.getTransportModeIcon(value)}
                ></span>
              ) : (
                <span className={"icon-sea-shipment icons-front-module"} />
              )}
            </div>
          );
        },
      },
      {
        label: this.props.t("progress"),
        xls: false,
        data: { link: false, progress: true, icon: false, status: false },
        key: "Progress",
        minWidth: 100,
        maxWidth: 100,
        className: "col-md-3 col-lg-1 col-sm-6",
        custom: (value) => (
          <div>
            <center style={{ marginBottom: "4px" }}></center>
            <Progress color="pink" value={value.Progress} />
          </div>
        ),
      },
      {
        label: this.props.t("status"),
        key: "Status",
        minWidth: 0,
        maxWidth: 0,
        custom: (value) => <span class="badge badge-euro">{value.Status}</span>,
        className: "col-md-3 col-lg-2 col-sm-6",
      },
      {
        label: this.props.t("shipment_num"),
        key: "ShipmentId",
        minWidth: 220,
        maxWidth: 220,
        className: "col-md-3 col-lg-2 col-sm-6",
        custom: (value) => (
          <Link
            className="underline-link"
            to={"/shipments-details/" + value.ShipmentId}
          >
            {value.ShipmentNumber}
          </Link>
        ),
      },
      {
        label: this.props.t("transport_order"),
        key: "TransportOrderNo",
        xls: true,
        minWidth: 220,
        maxWidth: 220,
        custom: (value) => <span>{value.TransportOrderNo}</span>,
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("company"),
        key: "CustomerName",
        minWidth: 220,
        maxWidth: 220,
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("shipper"),
        key: "ShipperName",
        minWidth: 220,
        maxWidth: 220,
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("consignee"),
        xls: true,
        minWidth: 220,
        maxWidth: 220,
        key: "ConsigneeName",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("reference"),
        xls: true,
        minWidth: 220,
        maxWidth: 220,
        key: "CustomertRef",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("order_ref"),
        xls: true,
        type: 7,
        key: "refclientepo",
        minWidth: 220,
        maxWidth: 220,
        className: "col-md-2 col-lg-1 col-sm-1",
      },
      {
        label: this.props.t("reference_type"),
        xls: true,
        key: "ReferenceType",
        minWidth: 175,
        maxWidth: 200,
        className: "col-md-2 col-lg-1 col-sm-1",
      },
      {
        label: this.props.t("shipment_type"),
        xls: true,
        type: 7,
        key: "ShipmentType",
        minWidth: 220,
        maxWidth: 220,
        className: "col-md-2 col-lg-1 col-sm-1",
      },

      {
        label: this.props.t("container"),
        xls: true,
        type: 7,
        minWidth: 220,
        maxWidth: 220,
        key: "Containers",
        className: "col-md-2 col-lg-1 col-sm-1",
      },
      {
        label: "HBL/AWB",
        xls: true,
        type: 7,
        key: "HBL_HAWB",
        className: "col-md-2 col-lg-1 col-sm-1",
      },
      {
        label: this.props.t("origin"),
        xls: true,
        link: "/shipments-details/",
        key: "POL",
        // id2: "POLName",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("destination"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        link: "/shipments-details/",
        key: "POD",
        // id2: "PODName",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("etd"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        key: "ETD",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      // {
      //   label: this.props.t("newETD"),
      //   xls: true,
      //   data: { link: false, progress: false, icon: false, status: false },
      //   link: "/shipments-details/",
      //   key: "NewETD",
      //   className: "col-md-3 col-lg-1 col-sm-6",
      // },
      {
        label: this.props.t("atd"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        key: "ATD",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("eta"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        link: "/shipments-details/",
        key: "ETA",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      // {
      //   label: this.props.t("newETA"),
      //   xls: true,
      //   data: { link: false, progress: false, icon: false, status: false },
      //   key: "NewETA",
      //   className: "col-md-3 col-lg-1 col-sm-6",
      // },
      {
        label: this.props.t("ata"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        link: "/shipments-details/",
        key: "ATA",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("total_co2_generated"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        key: "CO2",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("traveled_kilometers"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        key: "Distance",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      {
        label: this.props.t("average_co2"),
        xls: true,
        data: { link: false, progress: false, icon: false, status: false },
        key: "Average",
        className: "col-md-3 col-lg-1 col-sm-6",
      },
      // {title: '',id:'null',link:'/shipments-details/',className: ''},
    ],
    advancedSearch2: FormFiltros,
    advancedSearchTCC: [...FormFiltros],
    advancedSearch: [],
    advancedObj: [],
    advancedOrderObj: [],
    url: "",
    filtrosTCC: null,
    activeTab: 0,
  };

  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    // console.log("isMobileDevice-->", isMobileDevice);
    this.setState({
      isMovil: isMobileDevice,
    });

    this.getListShipments();
    this.getListShipmentsTCC();
    this.getCatalogs();
    this.getMapShipments();
    this.OTgetResults();
    this.GenerateExtraFilter();
    // this.resetAdvance()
    this.reset();

    window.addEventListener("resize", () => {
      let newGraphs = this.state.graphs;
      newGraphs.map((e) => {
        e.width = this.calculateWidth();
        return e;
      });
      this.setState({ graphs: newGraphs });
    });
  };

  getCommnets = (item, NewComments) => {
    let { CustomerId, ShipmentId } = item;

    let moduleId = 3;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/get-comment?rowid=${ShipmentId}&moduleid=${moduleId}&general=false&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        let comentario = response.data.Comment;
        this.getUserMenciones(comentario, CustomerId, ShipmentId, item);

        if (NewComments) {
          openNotification("success", NewComments);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTransportModeIcon = (shipment) => {
    const DicIcon = {
      maritimo: "icon-sea-shipment icons-front-module",
      terrestre: "icon-ground-shipment icons-front-module",
      aereo: "icon-air-shipment icons-front-module",
      rail: "icon-shipment-rail icons-front-module",
      tcc_priority: "icon-priority-tcc icons-front-module",
      tcc_obc: "icon-obc-shipment icons-front-module",
      tcc_ground: "icon-charter-shipment2 icons-front-module",
      tcc_charter: "icon-air-charter-shipment icons-front-module",
    };
    if (shipment.TCC === "1") {
      if (shipment.ShipmentTypeId === 58 || shipment.ShipmentTypeId === 25) {
        return DicIcon.tcc_priority;
      } else if (shipment.ShipmentTypeId === 2) {
        return DicIcon.tcc_charter;
      } else if (
        shipment.ShipmentTypeId === 59 ||
        shipment.ShipmentTypeId === 23
      ) {
        return DicIcon.tcc_obc;
      }
      return DicIcon.tcc_ground;
    } else {
      if (shipment.TransportModeCode === 2) {
        return DicIcon.aereo;
      } else if (shipment.TransportModeCode === 1) {
        return DicIcon.maritimo;
      } else if (shipment.TransportModeCode === 4) {
        return DicIcon.rail;
      }
      return DicIcon.terrestre;
    }
  };

  getUserMenciones = (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;
    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/getUserMension?CustomerId=${CustomerId}&user=${userId}`
      )
      .then((response) => {
        this.setState({
          commentsData: comentario,
          users: response.data.data,
          rowid: ShipmentId,
          itemCommenSelect: item,
          loadercomments: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  newMessage = async (data) => {
    let { userId, rowid, itemCommenSelect } = this.state;

    data.Rowid = rowid;
    data.UserId = userId;
    data.ModuleId = 3;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/add-comment`, data)
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_saved")
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    let { itemCommenSelect } = this.state;

    axios
      .delete(
        `${Services.TRACEABILITY.path}trazabilidad/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommnets(
          itemCommenSelect,
          this.props.t("comment_successfully_deleted")
        );
        toggle();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  OTgetResults = async () => {
    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPageOrder,
      limit: this.state.limitOrder,
      EsDTA: 0,
      search: this.state.searchOrder,
      advanced: this.state.advancedObj,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/listOrders`, data)
      .then((success) => {
        let data = success.data.data;
        this.setState({
          dataOrder: data,
          pagesOrder: success.data.totalPage,
          fullLoader: true,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getCatalogs = () => {
    let data = {
      client: this.state.clientesSelect,
      userId: this.props._user,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/catalogShipment`, data)
      .then((success) => {
        let catalogCombo = success.data.data;
        this.setState(
          {
            catalogCombo,
          },
          () => {
            this.generateFilters();
            this.generateFiltersTCC();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getListShipments = () => {
    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPage,
      limit: this.state.limit,
      lang: this.props.lng,
      userId: this.state.userId,
      EsDTA: 0,
      search: this.state.search,
      advanced: this.state.advancedObj,
    };
    this.setState({
      url: encodeURI(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${this.state.search}&allData=true`
      ),
      paramsxml: data,
    });
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/listShipments`, data)
      .then((success) => {
        let data = success.data.data.map((e) => {
          let TraspormodeId = 1;
          e.TraspormodeId = TraspormodeId;
          e.id = e.ShipmentNumber;
          return e;
        });
        this.setState({
          totalPages: success.data.totalPage,
          totalPagesExt: success.data.totalPage,
          data: data,
          dataAux: data,
          dataOut: data,
          fullLoader: true,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getListShipmentsTCC = async () => {
    try {
      const {
        clientesSelect,
        userId,
        numberPageTCC,
        limitTCC,
        searchTCC,
        advancedObjTCC,
      } = this.state;
      const data = {
        client: clientesSelect,
        pag: numberPageTCC,
        limit: limitTCC,
        lang: this.props.lng,
        userId: userId,
        EsDTA: 0,
        search: searchTCC,
        advanced: advancedObjTCC,
        isTCC: true,
      };
      this.setState({
        url: encodeURI(
          `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${searchTCC}&allData=true`
        ),
        paramsxml: data,
      });
      const success = await axios.post(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments`,
        data
      );
      let shippmentsTCC = success.data.data.map((e) => {
        let TraspormodeId = 1;
        e.TraspormodeId = TraspormodeId;
        e.id = e.ShipmentNumber;
        return e;
      });
      this.setState({
        totalPagesTCC: success.data.totalPage,
        totalPagesExtTCC: success.data.totalPage,
        shippmentsTCC: shippmentsTCC,
        shippmentsTCCaux: shippmentsTCC,
        shippmentsTCCOut: shippmentsTCC,
        fullLoader: true,
      });
    } catch (error) {
      console.warn("getListShipmentsTCC", error);
    }
  };

  setAdvanced = (val) => {
    this.setState({ advancedObj: val }, () => {
      this.getListShipments();
    });
  };

  markerPin = (e) => {
    if (e.TCC === "1") {
      return "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png";
    }
    return "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapa.png";
  };

  validatePriority = (val) => {
    if (
      val.PriorityShipment === "Si" ||
      val.PriorityShipment === "Yes" ||
      val.TCC === "1"
    ) {
      return true;
    }
    return false;
  };

  getMapShipments = () => {
    statusInter.map((e) => {
      e.count = 0;
      return e;
    });

    let data = {
      client: this.state.clientesSelect,
      userId: this.state.userId,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/MapsShipments`, data)
      .then((success) => {
        let markers = [];
        let polylineData = [];

        success.data.data.map((e, index) => {
          if (
            e.POLLatitude &&
            e.POLLongitude &&
            e.PODLatitude &&
            e.PODLongitude
          ) {
            if (e.POLLatitude && e.POLLongitude) {
              let obj = {
                anchorX: 0,
                anchorY: 0,
                key: `${index}From`,
                title: this.props.t("origin"),
                name: e.ShipmentId,
                data: e,
                position: {
                  lat: e.POLLatitude,
                  lng: e.POLLongitude,
                },
                icon: {
                  url: this.markerPin(e),
                },
              };

              let position = {
                lat: Number(e.POLLatitude),
                lng: Number(e.POLLongitude),
              };
              polylineData.push(position);
              markers.push(obj);
            }
            if (e.PODLatitude && e.PODLongitude) {
              let obj = {
                key: `${index}To`,
                title: this.props.t("destination"),
                name: e.ShipmentId,
                anchorX: 0,
                anchorY: 0,
                data: e,
                position: {
                  lat: e.PODLatitude,
                  lng: e.PODLongitude,
                },
                icon: {
                  url: this.markerPin(e),
                },
              };
              let position = {
                lat: Number(e.PODLatitude),
                lng: Number(e.PODLongitude),
              };
              polylineData.push(position);
              markers.push(obj);
            }
          }
          return e;
        });
        this.setState(
          {
            markers: markers,
            dataMap: polylineData,
            polyline: polylineData,
            fullLoader: true,
          },
          () => {
            this.setState({
              map: (
                <Suspense fallback={<div>Loading...</div>}>
                  <Map
                    polylineData={this.state.polylineData}
                    heidIcon={20}
                    style={{ maxHeight: "300px" }}
                    marker={this.state.markers}
                    visible={true}
                    type={"polylineDrawer"}
                    data={this.state.polylineData}
                    dataDrawer={this.state.dataDrawer}
                    zoom={3}
                  />
                </Suspense>
              ),
              graphs: [
                {
                  title: "Operaciones por Modo de Transporte",
                  type: "pie",
                  data: this.state.donutChart,
                  width: this.calculateWidth(),
                  height: "280",
                },
                {
                  title: "Operaciones por Tráfico",
                  type: "pie",
                  data: this.state.donutChartTrafico,
                  width: this.calculateWidth(),
                  height: "280",
                },
                {
                  title: "Operaciones por Estatus",
                  type: "bar",
                  data: this.state.barTable,
                  width: this.calculateWidth(),
                  height: "280",
                  left: 120,
                },
              ],
            });
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  changePage = (e, { activePageOrder }) => {
    this.setState(
      {
        numberPage: activePageOrder,
        activePage: activePageOrder,
        fullLoader: false,
      },
      () => {
        this.getListShipments();
      }
    );
  };

  changePageTCC = (e, { activePageOrder }) => {
    this.setState(
      {
        numberPageTCC: activePageOrder,
        activePageTCC: activePageOrder,
      },
      () => {
        this.getListShipmentsTCC();
      }
    );
  };

  changePageOrder = (page) => {
    this.setState(
      {
        numberPageOrder: page,
        activePageOrder: page,
      },
      () => {
        this.OTgetResults();
      }
    );
  };

  GenerateExtraFilter = () => {
    let { extraFilter, priorityChecked } = this.state;
    extraFilter = (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          marginLeft: "10px",
        }}
      >
        <Tooltip
          title={
            <label className="label-euro normal">
              {this.props.t("filter_priority")}
            </label>
          }
        >
          <span className="icon-priority-shipments icons-front-module orange" />
        </Tooltip>
        <Switch
          className="form-input-switch"
          checked={priorityChecked}
          onChange={this.handlePriorityChange}
        ></Switch>
      </div>
    );
    this.setState({ extraFilter });
  };

  handlePriorityChange = (event) => {
    let { advancedSearch2, priorityChecked } = this.state;
    priorityChecked = event;
    let obj = advancedSearch2.find((adv) => {
      return adv.id === "PriorityShipment";
    });
    if (!obj) {
      advancedSearch2.push({ id: "PriorityShipment", val: "", UseIN: false });
    }
    advancedSearch2.map((adv) => {
      if (adv.id === "PriorityShipment") {
        if (event) {
          adv.value = this.props.t("yes");
        } else {
          adv.value = "";
        }
      }
    });

    this.setState({ advancedSearch2, priorityChecked }, () => {
      this.GenerateExtraFilter();
      this.findAdvanced();
    });
  };

  handleChange = () => (event) => {
    let val = event.target.value;
    if (!this.state.isSearch) {
      this.setState({ isSearch: true }, () => {
        this.setState(
          {
            search: val,
            activePage: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          }
        );
      });
    }
  };

  newSearch = (val) => {
    if (val.length < 1) {
      this.setState(
        {
          search: val,
          isSearch: false,
          activePage: 1,
          limit: 10,
          numberPage: 1,
          totalPages: 1,
        },
        () => {
          this.getListShipments();
        }
      );
    } else {
      if (val.length < this.state.search.length) {
        this.setState(
          {
            search: val,
            activePage: 1,
            limit: 10,
            numberPage: 1,
            totalPages: 1,
          },
          () => {
            this.getListShipments();
          }
        );
      } else {
        this.setState({ search: val }, () => {
          this.getListShipments();
        });
      }
    }
  };

  calculateWidth = () => {
    if (window.innerWidth >= 1756) {
      return (window.innerWidth / 4.8).toString();
    } else {
      return (window.innerWidth / 5.5).toString();
    }
  };

  handleSelectedFile = (value) => {
    try {
      let { activePage, activePageTCC, activeTab, dataAux, shippmentsTCCaux } =
        this.state;
      let dataSentFilter = activeTab === 0 ? dataAux : shippmentsTCCaux;
      let out = this.searchSelected(value, dataSentFilter);

      if (activeTab === 0) {
        this.setState({
          activePage: 1,
          totalPages: 1,
          data: [out],
          labelSelected: value,
          previousPage: activePage,
          selected: value,
        });
      } else {
        this.setState({
          activePageTCC: 1,
          totalPagesTCC: 1,
          shippmentsTCC: [out],
          labelSelected: value,
          previousPage: activePageTCC,
          selected: value,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  searchSelected = (ID, dataAux) => {
    // let { dataAux, activeTab, shipmentsTCCAux } = this.state;
    let FOUND = dataAux.find((o) => o.id === ID);
    return FOUND;
  };
  toggleDrawerMap = (data) => (evt) => {
    if (evt) evt.preventDefault();
    this.handleSelectedFile(data.id);
    this.setState({ visible: true, dataDrawer: data }, () => {
      this.setState({
        map: (
          <Suspense fallback={<div>Loading...</div>}>
            <Map
              polylineData={this.state.polylineData}
              heidIcon={20}
              style={{ maxHeight: "300px" }}
              marker={this.state.markers}
              visible={true}
              type={"polylineDrawer"}
              data={this.state.polylineData}
              dataDrawer={this.state.dataDrawer}
              zoom={3}
            />
          </Suspense>
        ),
      });
    });
  };

  redirectTo = (id) => (evt) => {
    // evt.preventDefault();
    // this.props.history.push('/tracking/'+id)
  };

  updateMap = () => {
    this.setState({
      map: (
        <Suspense fallback={<div>Loading...</div>}>
          <Map
            polylineData={this.state.polylineData}
            heidIcon={20}
            style={{ maxHeight: "300px" }}
            marker={this.state.markers}
            visible={true}
            type={"polylineDrawer"}
            data={this.state.polylineData}
            dataDrawer={this.state.dataDrawer}
            zoom={3}
            showDrawerInfo={false}
          />
        </Suspense>
      ),
    });
  };

  resetTableCards = (evt, type) => {
    evt.preventDefault();
    let {
      dataAux,
      shippmentsTCCaux,
      totalPagesExt,
      totalPagesExtTCC,
      previousPage,
    } = this.state;

    if (type === 0) {
      this.setState(
        {
          data: _.cloneDeep(dataAux),
          labelSelected: "",
          activePage: previousPage ? previousPage : 1,
          totalPages: totalPagesExt,
          dataDrawer: "",
        },
        () => this.updateMap()
      );
    } else {
      this.setState(
        {
          shippmentsTCC: _.cloneDeep(shippmentsTCCaux),
          labelSelected: "",
          activePageTCC: previousPage ? previousPage : 1,
          totalPagesTCC: totalPagesExtTCC,
          dataDrawer: "",
        },
        () => this.updateMap()
      );
    }
  };

  backres = (backResponse) => {
    this.setState({
      data: backResponse,
      dataAux: backResponse,
      dataOut: backResponse,
    });
  };
  resetAdvance = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.map((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearch2 }, () => {
      this.findAdvanced();
      this.generateFilters();
    });
  };

  reset = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.map((advData) => {
      advData.values = [];
    });
  };

  resetAdvanceTCC = () => {
    let { advancedSearchTCC } = this.state;
    advancedSearchTCC.map((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearchTCC }, () => {
      this.findAdvancedTCC();
      this.generateFiltersTCC();
    });
  };

  generateFilters = () => {
    const { advancedSearch2, catalogCombo } = this.state;
    let Inputs = advancedSearch2.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              noResultsMessage={this.props.t("no_results_found")}
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
    });
    let NewInput = (
      <div className="row">
        <div className="col-12">
          <span
            className="icon-clear icons-front-module float-right"
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>
        {Inputs}
      </div>
    );

    this.setState({
      filtros: NewInput,
    });
  };

  generateFiltersTCC = () => {
    const { catalogCombo, advancedSearchTCC } = this.state;
    const InputsTCC = advancedSearchTCC.map((e) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                        moment.utc(new Date(e.values[0].init)),
                        moment.utc(new Date(e.values[0].end)),
                      ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
                // fontSize:'12px'
              }}
              id={e.id}
              onChange={this.handleChangeDatePickerTCC(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultipleTCC(e.id, value)
              }
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              floating
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
    });

    const NewInputTCC = (
      <div className="row">
        <div className="col-12">
          <span
            className="icon-clear icons-front-module float-right"
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvanceTCC}
          />
        </div>
        {InputsTCC}
      </div>
    );

    this.setState({
      filtrosTCC: NewInputTCC,
    });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch2 } = this.state;
    for (let i = 0; i < advancedSearch2.length; i++) {
      const e = advancedSearch2[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearch2 }, () => {
      this.generateFilters();
      this.findAdvanced();
    });
  };

  handleChangeSelectMultipleTCC = (id, value) => {
    let { advancedSearchTCC } = this.state;
    for (let i = 0; i < advancedSearchTCC.length; i++) {
      const e = advancedSearchTCC[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearchTCC }, () => {
      this.generateFiltersTCC();
      this.findAdvancedTCC();
    });
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch2 } = this.state;

    try {
      if (event) {
        advancedSearch2.map((search) => {
          if (search.id === name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD"),
                end: event[1].format("YYYY-MM-DD"),
              },
            ];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.findAdvanced();
        });
      } else {
        advancedSearch2.map((search) => {
          if (search.id === name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  handleChangeDatePickerTCC = (name) => (event) => {
    let { advancedSearchTCC } = this.state;

    try {
      if (event) {
        advancedSearchTCC.map((search) => {
          if (search.id == name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD"),
                end: event[1].format("YYYY-MM-DD"),
              },
            ];
          }
        });
        this.setState({ advancedSearchTCC }, () => {
          this.generateFiltersTCC();
          this.findAdvancedTCC();
        });
      } else {
        advancedSearchTCC.map((search) => {
          if (search.id == name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearchTCC }, () => {
          this.generateFiltersTCC();
          this.findAdvancedTCC();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearch2.map((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    this.setState(
      {
        advancedObj: obj,
        numberPage: 1,
        activePage: 1,
      },
      () => {
        this.getListShipments();
      }
    );
  };

  findAdvancedTCC = () => {
    let obj = [];
    this.state.advancedSearchTCC.map((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    this.setState(
      {
        advancedObjTCC: obj,
        numberPageTCC: 1,
        activePageTCC: 1,
      },
      () => {
        this.getListShipmentsTCC();
      }
    );
  };

  generateOrderExcel = () => {
    this.setState({
      excelOrderLoading: true,
    });

    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPageOrder,
      limit: this.state.limitOrder,
      EsDTA: 0,
      search: this.state.searchOrder,
      advanced: this.state.advancedOrderObj,
      query: {
        allData: true,
        noGroup: true,
      },
      lang: this.props.lng,
    };

    // this.setState({ url: encodeURI(`${Services.TRACEABILITY.path}trazabilidad/listOrders?search=${this.state.search}&allData=true`), paramsxml: data });
    // // axios.post(`${Services.Get_Traceability_Shipments.path}shipments/listShipments`, data, {params:{pag:this.state.numberPage,limit:this.state.limit, EsDTA:0, search: this.state.search}} ).then(success => {
    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/listOrders`, data)
      .then((success) => {
        let data = success.data.data;
        let dateNow = new Date();
        let titleDownload = `${this.props.t("consol_services")}-${
          dateNow.getFullYear() +
          (dateNow.getMonth() + 1).toString().padStart(2, "0") +
          dateNow.getDate().toString().padStart(2, "0")
        }.xlsx`;
        let info = {
          config: {},
        };

        let options = {
          headers: this.state.orderHeaders,
          keys: this.state.orderKeys,
          image: {
            name: "euro",
          },
          sheetName: this.props.t("consol_services"),
          font: "SF Pro Display",
        };
        axios
          .post(`${OrderServices.Dowload_Excel.path}report/dynamic/xlsx`, {
            info,
            data,
            options,
          })
          .then((success) => {
            if (success.data.base64) {
              const fileName = titleDownload + ".xlsx";
              const linkSource = `data:application/xlsx;base64,${success.data.base64}`;
              saveAs(linkSource, fileName);
              this.setState({
                loading: false,
                excelOrderLoading: false,
              });
            } else {
              openNotification(
                "error",
                this.props.t("excel_export_fails_data")
              );
              this.setState({ excelOrderLoading: false });
            }
          });
      })
      .catch((error) => {
        openNotification("error", this.props.t("excel_export_fails"));
        this.setState({
          loading: false,
        });
        console.warn(error);
      });
  };

  generateShipmentExcel = async () => {
    try {
      this.setState({
        excelShipmentLoading: true,
      });

      let data = {
        client: this.state.clientesSelect,
        pag: this.state.numberPage,
        lang: this.props.lng,
        userId: this.state.userId,
        limit: this.state.limit,
        EsDTA: 0,
        search: this.state.search,
        advanced: this.state.advancedObj,
        allData: true,
      };

      this.setState({
        url: encodeURI(
          `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${this.state.search}&allData=true`
        ),
        paramsxml: data,
      });

      const listShipments = await axios.post(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments`,
        data
      );
      if (listShipments.data.data.length === 0) {
        openNotification("error", this.props.t("excel_export_fails_data"));
        this.setState({
          excelShipmentLoading: false,
        });
        return;
      }
      let dateNow = new Date();
      let titleDownload = `${this.props.t("shipment_list")}-${
        dateNow.getFullYear() +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        dateNow.getDate().toString().padStart(2, "0")
      }`;
      let info = {
        config: {},
      };

      let options = {
        headers: this.state.headers,
        keys: this.state.keys,
        image: {
          name: "euro",
        },
        sheetName: this.props.t("shipments"),
        font: "SF Pro Display",
      };
      const excel = await axios.post(
        `${OrderServices.Dowload_Excel.path}report/dynamic/xlsx`,
        {
          info,
          data: listShipments.data.data,
          options,
        }
      );
      if (excel.data.base64) {
        const fileName = titleDownload + ".xlsx";
        const linkSource = `data:application/xlsx;base64,${excel.data.base64}`;
        saveAs(linkSource, fileName);
      } else {
        console.warn("Error downloading file", excel);
        openNotification("error", this.props.t("excel_export_fails"));
      }
    } catch (error) {
      console.warn(error);
      openNotification("error", this.props.t("excel_export_fails"));
    } finally {
      this.setState({
        excelShipmentLoading: false,
      });
    }
  };

  generateShipmentExcelTCC = async () => {
    try {
      const {
        clientesSelect,
        userId,
        numberPageTCC,
        limitTCC,
        searchTCC,
        advancedObjTCC,
        headers,
        keys,
      } = this.state;
      this.setState({
        excelShipmentLoading: true,
      });

      const data = {
        client: clientesSelect,
        pag: numberPageTCC,
        lang: this.props.lng,
        userId: userId,
        limit: limitTCC,
        EsDTA: 0,
        search: searchTCC,
        advanced: advancedObjTCC,
        allData: true,
        isTCC: true,
      };

      this.setState({
        url: encodeURI(
          `${Services.TRACEABILITY.path}trazabilidad/listShipments?search=${searchTCC}&allData=true`
        ),
        paramsxml: data,
      });
      const success = await axios.post(
        `${Services.TRACEABILITY.path}trazabilidad/listShipments`,
        data
      );
      const shipmentTCC = success.data.data;
      const dateNow = new Date();
      const titleDownload = `${this.props.t("shipments_tcc")}-${
        dateNow.getFullYear() +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        dateNow.getDate().toString().padStart(2, "0")
      }`;
      const info = {
        config: {},
      };

      const options = {
        headers,
        keys: keys,
        image: {
          name: "euro",
        },
        sheetName: this.props.t("shipments_tcc"),
        font: "SF Pro Display",
      };
      if (shipmentTCC.length === 0) {
        openNotification("error", this.props.t("excel_export_fails_data"));
        this.setState({
          excelShipmentLoading: false,
        });
        return;
      }
      const successBase64 = await axios.post(
        `${OrderServices.Dowload_Excel.path}report/dynamic/xlsx`,
        {
          info,
          data: shipmentTCC,
          options,
        }
      );
      if (successBase64.data.base64) {
        const fileName = titleDownload + ".xlsx";
        const linkSource = `data:application/xlsx;base64,${successBase64.data.base64}`;
        saveAs(linkSource, fileName);
        this.setState({
          excelShipmentLoading: false,
        });
      } else {
        openNotification("error", this.props.t("excel_export_fails"));
        console.warn("Error downloading file", success);
      }
    } catch (error) {
      console.warn("generateShipmentExcelTCC", error);
      openNotification("error", this.props.t("excel_export_fails"));
      this.setState({
        excelShipmentLoading: false,
      });
    }
  };

  setOrderSearch = (search) => {
    this.setState(
      {
        searchOrder: search,
        activePageOrder: 1,
        numberPageOrder: 1,
        fullLoader: false,
      },
      () => {
        this.OTgetResults();
      }
    );
  };

  setShipmentSearch = (value) => {
    if (this.state.search === value) return;

    this.setState(
      {
        search: value,
        activePage: 1,
        numberPage: 1,
        fullLoader: false,
      },
      () => {
        this.getListShipments();
      }
    );
  };

  setShipmentSearchTCC = (value) => {
    if (this.state.searchTCC === value) return;

    this.setState(
      {
        searchTCC: value,
        activePageTCC: 1,
        numberPageTCC: 1,
        fullLoader: false,
      },
      () => {
        this.getListShipmentsTCC();
      }
    );
  };

  loadTab = (_evt, { activeIndex }) => {
    this.GenerateExtraFilter();
    this.setState(
      {
        activeTab: activeIndex,
        labelSelected: "",
        dataDrawer: "",
        activePage: 1,
        activePageTCC: 1,
        numberPage: 1,
        numberPageTCC: 1,
      },
      () => {
        this.getListShipments();
        this.getListShipmentsTCC();
        this.updateMap();
      }
    );
  };

  renderShipmentsTCC = () => {
    const {
      isMovil,
      viewModalComments,
      loadercomments,
      commentsData,
      users,
      rolId,
      userId,
      scrollLine,
      itemCommenSelect,
      shippmentsTCC,
      filtrosTCC,
      searchTCC,
      labelSelected,
      config,
      excelShipmentLoading,
      activePageTCC,
      totalPagesTCC,
    } = this.state;

    return (
      <Row key="TCC">
        <Col md={12} xl={12}>
          <Suspense fallback={<div>Loading...</div>}>
            <Sidebar.Pushable as={Segment}>
              <Sidebar
                as={Menu}
                animation="overlay"
                icon="labeled"
                style={{
                  maxHeight: "84%!important",
                  width: isMovil
                    ? window.innerWidth - window.innerWidth * 0.1
                    : 400,
                }}
                direction="right"
                vertical
                id="sidebarComents"
                visible={viewModalComments}
                className="custom-sidebar"
              >
                <div className=" col-12 close_container">
                  <div className="header_comments">
                    {itemCommenSelect ? itemCommenSelect.ShipmentNumber : ""}
                  </div>
                  <div
                    className="close_icon2"
                    onClick={() => {
                      this.setState({ viewModalComments: false });
                    }}
                  >
                    <ButtonAnt size="small" type="primary" shape="circle">
                      X
                    </ButtonAnt>
                  </div>
                </div>
                <div style={{ height: "3em" }} className=" col-12">
                  {" "}
                </div>

                {loadercomments === true ? (
                  <Skeleton active paragraph={{ rows: 17 }} />
                ) : (
                  <div className=" col-12">
                    <Comments
                      commentTableList={true}
                      rolId={rolId}
                      userId={userId}
                      data={commentsData}
                      catalogs={users}
                      scrollLine={scrollLine}
                      funtionNewMessage={this.newMessage}
                      funtionDeleteMessage={this.deleteMessage}
                    />
                  </div>
                )}
              </Sidebar>
              <Sidebar.Pusher>
                <Segment basic>
                  <DataTable
                    key="TCC-table"
                    reset={(event) => this.resetTableCards(event, 1)}
                    filtrosPanel={filtrosTCC}
                    labelSelected={labelSelected}
                    search={searchTCC}
                    panel={true}
                    data={shippmentsTCC}
                    columnsTable={[...config]}
                    onRowClick={this.toggleDrawerMap}
                    excelLoading={excelShipmentLoading}
                    handleSearch={this.setShipmentSearchTCC}
                    downloadExcel={this.generateShipmentExcelTCC}
                    activePage={activePageTCC}
                    pages={totalPagesTCC}
                    OnPageChange={this.changePageTCC}
                  />
                </Segment>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          </Suspense>
        </Col>
      </Row>
    );
  };

  render() {
    var timestamp = Date.now();
    var date = new Date(timestamp);
    let {
      fullLoader,
      viewModalComments,
      commentsData,
      users,
      rolId,
      userId,
      scrollLine,
      loadercomments,
      itemCommenSelect,
      isMovil,
      activeTab,
    } = this.state;

    return (
      <ContentWrapper>
        <Loader hidden={fullLoader}></Loader>
        <div className="content-heading">
          <span className="icon-shipments-visibility icon-header" />
          {this.props.t("shipmentsVisibility")}
        </div>
        {this.state.map}

        <br></br>
        <Tab
          loading={true}
          onTabChange={this.loadTab}
          menu={{
            secondary: true,
            pointing: true,
            className: "custom-specific-tab-menu",
          }}
          panes={[
            {
              menuItem: this.props.t("shipments"),
              render: () => (
                <Row>
                  <Col md={12} xl={12}>
                    <Suspense fallback={<div>Loading...</div>}>
                      <Sidebar.Pushable as={Segment}>
                        <Sidebar
                          as={Menu}
                          animation="overlay"
                          icon="labeled"
                          style={{
                            maxHeight: "84%!important",
                            width: isMovil
                              ? window.innerWidth - window.innerWidth * 0.1
                              : 400,
                          }}
                          // style={{ maxHeight: "84%!important" }}
                          direction="right"
                          // onHide={() => setVisible(false)}
                          vertical
                          id="sidebarComents"
                          visible={viewModalComments}
                          className="custom-sidebar"
                          // width={window.innerWidth < 993 ? 'wide' : 'very wide'}
                        >
                          <div className=" col-12 close_container">
                            <div className="header_comments">
                              {itemCommenSelect
                                ? itemCommenSelect.ShipmentNumber
                                : ""}
                            </div>
                            <div
                              className="close_icon2"
                              // style={{ marginTop: '8px !important' }}

                              onClick={() => {
                                this.setState({ viewModalComments: false });
                              }}
                            >
                              <ButtonAnt
                                size="small"
                                type="primary"
                                shape="circle"
                              >
                                X
                              </ButtonAnt>
                            </div>
                          </div>
                          <div style={{ height: "3em" }} className=" col-12">
                            {" "}
                          </div>

                          {loadercomments === true ? (
                            <Skeleton active paragraph={{ rows: 17 }} />
                          ) : (
                            <div className=" col-12">
                              <Comments
                                commentTableList={true}
                                rolId={rolId}
                                userId={userId}
                                data={commentsData}
                                catalogs={users}
                                scrollLine={scrollLine}
                                funtionNewMessage={this.newMessage}
                                funtionDeleteMessage={this.deleteMessage}
                              />
                            </div>
                          )}
                        </Sidebar>

                        <Sidebar.Pusher>
                          <Segment
                            basic
                            // className="comments_table_container"
                          >
                            <DataTable
                              reset={(event) => this.resetTableCards(event, 0)}
                              filtrosPanel={this.state.filtros}
                              labelSelected={this.state.labelSelected}
                              search={this.state.search}
                              panel={true}
                              data={this.state.data}
                              columnsTable={this.state.config}
                              onRowClick={this.toggleDrawerMap}
                              excelLoading={this.state.excelShipmentLoading}
                              handleSearch={this.setShipmentSearch}
                              downloadExcel={this.generateShipmentExcel}
                              activePage={this.state.activePage}
                              pages={this.state.totalPages}
                              OnPageChange={this.changePage}
                              ExtraFilter={this.state.extraFilter}
                            ></DataTable>
                          </Segment>
                        </Sidebar.Pusher>
                      </Sidebar.Pushable>
                    </Suspense>
                  </Col>
                </Row>
              ),
            },
            {
              menuItem: this.props.t("shipments_tcc"),
              render: () => this.renderShipmentsTCC(),
            },
            {
              menuItem: this.props.t("consol_services"),
              render: () => (
                <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Ordentransport
                      data={this.state.dataOrder}
                      OnPageChange={(e, { activePageOrder }) =>
                        this.changePageOrder(activePageOrder)
                      }
                      search={this.state.searchOrder}
                      generateExcel={this.generateOrderExcel}
                      activePage={this.state.activePageOrder}
                      pages={this.state.pagesOrder}
                      setSearch={this.setOrderSearch}
                      excelLoading={this.state.excelOrderLoading}
                    />
                  </Suspense>
                </div>
              ),
            },
          ]}
        />
      </ContentWrapper>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Trazabilidad))
);
